import React from 'react';
import '../styles/MechheroExtra.css'; // we'll write styles here
import slide1 from '../assets/mc-6.webp';
import slide2 from '../assets/mc-7.png';
import slide3 from '../assets/mc-8.webp';
import slide4 from '../assets/mc-9.webp';
import slide5 from '../assets/mc10.jpg';
import slide6 from '../assets/mc7.jpg';
import slide7 from '../assets/mc-1.jpg';
import slide8 from '../assets/mc6.jpg';

const MechheroExtra = () => {
  const images = [slide1, slide2, slide3,slide4, slide5, slide6, slide7, slide8];

  return (
    <div className="mechhero-extra-container">
      <div className="parallax-bg" />
      <div className="content-wrapper">
        <div className="left-content">
          <h2>Innovative Mechanical Solutions</h2>
          <p>
            Discover our cutting-edge mechanical engineering services designed to boost efficiency, reliability, and sustainability in your projects. From concept to completion, we deliver excellence with precision and innovation.
          </p>
        </div>

        <div className="right-carousel">
          <div className="carousel-viewport">
            <div className="carousel-track">
              {images.concat(images).map((img, idx) => (
                <div className="carousel-slide" key={idx}>
                  <img src={img} alt={`Slide ${idx + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MechheroExtra;
